import {Component, Input, OnInit, Inject} from 'ng-metadata/core';
import {SourceRecordService} from './sourceRecord.service';

@Component({
    selector: 'prm-source-record',
    templateUrl: 'components/sourceRecord/source-record.html',

})

export class PrmSourceRecord implements OnInit{
    private sourceRecord : string;

    constructor(private sourceRecordService: SourceRecordService,
                @Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService) {

    }

    ngOnInit() {

            this.sourceRecordService.getSourceRecord(this.$stateParams['docId'],this.$stateParams['recordOwner']).then(
            (response) => this.sourceRecord = response.data,
             //(error) =>
             )

    }

     public getTemplateUrl() {
        return this.sourceRecord;
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/sourceRecord/sourceRecord.directive.ts